import React, {useState} from 'react';
import {Alert, Button, Form} from 'react-bootstrap';

import AuthService from "../../services/auth.service";
import {withRouter} from '../../common/with-router';
import pfLogo from '../../img/social-logo.png';
import '../../Auth.css';


const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [result, setResult] = useState(false);
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        if (!email) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Email is invalid';
        }
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            AuthService.forgotPass(email).then(
                () => {
                    setResult(true);
                },
                error => {
                    const newErrors = {};
                    newErrors.forgotPass = error.response.data.error
                    setErrors(newErrors);
                }
            )
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-form-container">
                <h2 className="auth-title">
                    <img src={pfLogo}
                         alt="Winchester Porchfest"
                         title="Winchester Porchfest"
                         height="80px"
                         className="profile-img-card"/>
                </h2>

                {!result &&
                    <p>Enter your email address below and we will email you a link to reset your password.</p>
                }
                {result &&
                    <>
                        <p>If your account exists, you will receive an email to <strong>{email}</strong> with
                            instructions on how to reset your password.</p>
                    </>
                }

                {!result &&
                    <Form.Group>
                        <Form onSubmit={handleSubmit} className="auth-form">
                            <Form.Group className="mb-3">
                                <Form.Label>Email address:</Form.Label>
                                <Form.Control
                                    type="email"
                                    // placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    isInvalid={!!errors.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>


                            <Button variant="primary" type="submit" className="auth-button">
                                Reset Password
                            </Button>

                            {errors && errors.forgotPass &&
                                <div>
                                    <br/>
                                    <Alert variant="danger">{errors.forgotPass}</Alert>
                                </div>
                            }
                        </Form>
                    </Form.Group>
                }
            </div>
        </div>
    );
}

export default withRouter(ForgotPassword);